import React, { createContext, useMemo, useState } from 'react'

export const FetchContext = createContext({
  resultList: null,
  setResultList: () => null,
  isAppendResults: null,
  setIsAppendResults: () => null,
})

export function FetchProvider({ children }) {
  const [resultList, setResultList] = useState({}) // Object
  const [isAppendResults, setIsAppendResults] = useState(false) // Boolean

  const value = useMemo(() => ({
    resultList,
    setResultList,
    isAppendResults,
    setIsAppendResults,
  }))
  return (
    <FetchContext.Provider value={value}>{children}</FetchContext.Provider>
  )
}
